// extracted by css-extract-rspack-plugin
export default {"form":"R74FdK","heading":"V1v42V"};